import {Component, OnInit, ViewChild} from '@angular/core';
import {IMeasurementRow} from '../new-measurement/new-measurement.component';
import {Store} from '@ngxs/store';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {ActivatedRoute, Params} from '@angular/router';
import {MessageAlertService} from '../../services/message-alert/message-alert.service';
import {StorageService} from '../../services/storage/storage.service';
import {firstValueFrom} from 'rxjs';
import {Loader} from '../../models/loader/loader.redux';
import {MeasurementAction, MeasurementState} from '../../models/measurement';
import {Logger} from '../../class/helper/logger.class';
import {IUser} from '../../models/auth';
import {ServiceAction, ServiceState} from '../../models/service';
import {cloneDeep} from 'lodash';
import {BasicFormulasComponent} from '../basic-formulas/basic-formulas.component';

@Component({
  selector: 'app-consultation-formulas',
  templateUrl: './consultation-formulas.component.html',
  styleUrls: ['./consultation-formulas.component.scss']
})
export class ConsultationFormulasComponent implements OnInit {
  @ViewChild(BasicFormulasComponent) basicFormulasComponent: BasicFormulasComponent;

  measurementsTemporal: IMeasurementRow[] = [];
  expertId: string;
  clinicId: string;
  patientId: string;
  serviceId: string;
  appointmentId: string;
  constructor(
    private store: Store,
    private utilitiesService: UtilitiesService,
    private activatedRoute: ActivatedRoute,
    private messageAlertService: MessageAlertService,
    private storageService: StorageService
  ) {

  }

  async ngOnInit(): Promise<void> {
    await this.setRouterParams();
    await this.initValuesHttp();
    await this.getMeasurementOfRedux();
  }

  /**
   * Obtiene los valores iniciales.
   */
  async initValuesHttp(): Promise<void> {
    await firstValueFrom((this.store.dispatch(new Loader(true, 'Obteniendo información ...'))));
    try {
      await firstValueFrom(this.store.dispatch(
        new MeasurementAction.GetAvailableFormulas(
          this.serviceId,
          this.patientId,
          this.expertId
        )));
    } catch (e) {
      Logger.log('Ocurrio un error', e?.message);
    } finally {
      await firstValueFrom((this.store.dispatch(new Loader(false))));

    }
  }


  /**
   * Setea los parametros de la url.
   */
  async setRouterParams(): Promise<void> {
    const params: Params = this.utilitiesService.getAllParams(this.activatedRoute);
    this.clinicId = params.clinicId;
    this.patientId = params.patientId;
    const userLogged = this.storageService.getLocalItem<{
      user: IUser;
      token: string;
    }>('user')?.user;
    if (userLogged && userLogged.experts) {
      this.expertId = userLogged.experts[0]._id;
    }

    this.serviceId = cloneDeep(await firstValueFrom((this.store.selectOnce(ServiceState.getServiceSelectedId))));
    if (!this.serviceId) {
      await firstValueFrom((this.store.dispatch(new ServiceAction.GetActive(this.patientId, this.expertId))));
      this.serviceId = cloneDeep(await firstValueFrom((this.store.selectOnce(ServiceState.getServiceSelectedId))));
    }
    this.activatedRoute.queryParams.subscribe((value) => {
      this.appointmentId = value.appointmentId;
      if (value.expert) {
        this.expertId = value.expert;
      }
    });
  }

  /**
   * Obtiene las mediciones que se quieren registrar.
   * son las mediciones del tab de mediciones. pero se guardan en el tab de diagnóstico.
   */
  async getMeasurementOfRedux(): Promise<void> {
    this.measurementsTemporal = cloneDeep(await firstValueFrom((this.store.selectOnce(MeasurementState.getMeasurementsTemp))));
    this.measurementsTemporal.forEach((item) => {
      if (!item.unitMeasurementDefault) {
        item.unitMeasurementDefault = item.unitMeasurement.find((measure) => measure._id === item.unit);
      }
    });
  }

}
